const stripDiacritics = (str: string): string => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

interface IToSlugOptions {
  trim?: boolean,
  separator?: string,
  replaceRegex?: RegExp,
  stripDiacritics?: boolean,
}

export const toSlug = (
  str: string,
  {
    replaceRegex = /[^A-Z0-9]+/ig,
    trim = true,
    separator = '-',
    stripDiacritics: shouldStripDiacritics = false,
  }: IToSlugOptions = {},
): string => {
  let slug = shouldStripDiacritics ? stripDiacritics(str) : str;

  slug = slug.toLowerCase().replace(replaceRegex, ' ');

  if (trim) {
    slug = slug.trim();
  }

  return slug.replace(/ /g, separator);
};
